import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  CreateDocumentTemplateMutation,
  CreateDocumentTemplateMutationVariables,
} from '@/gql/graphql';

const CreateDocumentTemplate = graphql(`
  mutation CreateDocumentTemplate($input: CreateDocumentTemplateInput!) {
    createDocumentTemplate(input: $input) {
      id
      name
      description
      templateHtml
    }
  }
`);

const useCreateDocumentTemplate = (
  options?: UseMutationOptions<
    CreateDocumentTemplateMutation,
    unknown,
    CreateDocumentTemplateMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CreateDocumentTemplate, {
        input,
      });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplates(),
      });
    },
    ...options,
  });
};

export default useCreateDocumentTemplate;
